<template>
  <div class="align">
    <div class="grid align__item">
      <div class="register">
        <img
          class="site__logo w-36 mx-auto"
          src="@/assets/img/logo.png"
          alt="Logo"
          height="60"
        />
        <h2 class="mb-6">NKR Group</h2>

        <!-- Recent users section -->
        <div
          v-if="
            mode === 'login' && recentUsers.length > 0 && !selectedRecentUser
          "
          class="mb-8"
        >
          <p class="text-gray-400 mb-4 text-sm uppercase tracking-wider">
            Recent Accounts
          </p>
          <div class="flex flex-wrap justify-center gap-4">
            <div
              v-for="user in recentUsers"
              :key="user.email"
              class="group cursor-pointer text-center"
              @click="selectUser(user)"
            >
              <div
                class="w-14 h-14 rounded-full bg-white border border-gray-100 group-hover:border-[#126e6a] transition-all flex items-center justify-center mb-2 mx-auto shadow-sm overflow-hidden"
              >
                <span class="text-2xl font-bold uppercase text-[#126e6a]">{{
                  user.name ? user.name[0] : user.email[0]
                }}</span>
              </div>
              <div
                class="text-[10px] text-gray-500 group-hover:text-gray-900 max-w-[80px] px-1 break-words line-clamp-2 leading-tight"
              >
                {{ user.name || user.email.split("@")[0] }}
              </div>
            </div>
            <div
              @click="
                selectedRecentUser = null;
                email = '';
                password = '';
              "
              class="group cursor-pointer text-center"
            >
              <div
                class="w-14 h-14 rounded-full border-2 border-dashed border-gray-700 group-hover:border-gray-500 transition-all flex items-center justify-center mb-2 mx-auto"
              >
                <span
                  class="text-2xl text-gray-500 group-hover:text-gray-300 transition-colors"
                  >+</span
                >
              </div>
              <div
                class="text-[10px] text-gray-500 group-hover:text-gray-300 px-1"
              >
                Other
              </div>
            </div>
          </div>
        </div>

        <form @submit.prevent="" class="form" v-if="mode == 'login'">
          <!-- Selected user display -->
          <div
            v-if="selectedRecentUser"
            class="mb-6 p-3 rounded-lg bg-white border border-gray-200 flex items-center justify-between shadow-sm"
          >
            <div class="flex items-center gap-3">
              <div
                class="w-10 h-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center shadow-inner"
              >
                <span class="text-lg font-bold uppercase text-[#126e6a]">{{
                  selectedRecentUser.name
                    ? selectedRecentUser.name[0]
                    : selectedRecentUser.email[0]
                }}</span>
              </div>
              <div class="text-left overflow-hidden">
                <div class="text-sm font-semibold text-gray-800 truncate">
                  {{ selectedRecentUser.name || "User" }}
                </div>
                <div class="text-[10px] text-gray-500 truncate">
                  {{ selectedRecentUser.email }}
                </div>
              </div>
            </div>
            <button
              type="button"
              @click="
                selectedRecentUser = null;
                email = '';
              "
              class="text-[10px] text-blue-600 hover:text-blue-500 font-bold ml-2 underline uppercase tracking-tighter"
            >
              Switch
            </button>
          </div>

          <div class="form__field" v-else>
            <input
              name="email"
              type="email"
              v-model="email"
              autocomplete="email"
              placeholder="info@mailaddress.com"
            />
          </div>

          <div class="form__field">
            <input
              name="password"
              type="password"
              autocomplete="password"
              v-model="password"
              placeholder="••••••••••••"
            />
          </div>
          <div v-if="errorMessage">{{ errorMessage }}</div>
          <div class="form__field">
            <input
              type="submit"
              @click="login()"
              :value="loading ? 'Loading...' : 'Log In'"
              :disabled="loading"
            />
          </div>
          <button type="button" @click="mode = 'password-recovery'">
            Forgot password?
          </button>
        </form>
        <div v-if="mode == 'password-recovery'">
          <h3 class="my-2">Recover password</h3>
          <form @submit.prevent="recoverPassword()" class="form">
            <div class="form__field">
              <input
                name="email"
                type="email"
                autocomplete="email"
                v-model="email"
                placeholder="name@nkrdieselparts.com"
              />
            </div>
            <div class="form__field">
              <input
                type="submit"
                :value="
                  loading ? 'Loading...' : 'Request password recovery link'
                "
                :disabled="loading"
              />
            </div>
            <p class="text-green-success" v-if="successMessage !== ''">
              {{ successMessage }}
            </p>
            <p class="text-red-cancel" v-if="errorMessage !== ''">
              {{ errorMessage }}
            </p>
            <button type="button" @click="mode = 'login'">
              I know my password, go to login.
            </button>
          </form>
        </div>
        <!-- <p>Already have an accout? <a href="#">Log in</a></p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { isLogged } from "@/middleware/Auth.js";
import { getRecoveryEmail } from "@/api/masterAdmin/Account.js";

export default {
  name: "loginPage",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      successMessage: "",
      loading: false,
      mode: "login",
      recentUsers: [],
      selectedRecentUser: null
    };
  },
  computed: {
    urlParams() {
      return {
        storeCode: this.activeStore,
        departmentCode: this.activeDepartment
      };
    },
    activeStore() {
      return this.$store.getters["general/getActiveStore"]?.code;
    }
  },
  mounted() {
    // eslint-disable-next-line no-console
    if (isLogged()) {
      this.$router.replace({ name: "store" });
    } else {
      const stored = localStorage.getItem("recent_users");
      if (stored) {
        try {
          this.recentUsers = JSON.parse(stored);
          // If we have one exact match in recent users, we could pre-select it,
          // but better to show the list if there are multiple.
          if (this.recentUsers.length === 1) {
            this.selectUser(this.recentUsers[0]);
          }
        } catch (e) {
          this.recentUsers = [];
        }
      }

      if (this.$route.query.cleared === "true") {
        this.$toast.open({
          message:
            "Application data was cleared due to update issues. Please log in again.",
          type: "info",
          duration: 10000
        });
      }
    }
  },
  methods: {
    recoverPassword() {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;
      getRecoveryEmail(this.email)
        .then(res => {
          const message = `${res.message} (${this.email})`;
          this.successMessage = message;
          this.email = "";
          this.$toast.open({
            message: "Recovery email sent",
            type: "success",
            position: "top-right"
          });
        })
        .catch(e => {
          this.errorMessage = e.response.data.message;
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async login() {
      this.loading = true;
      this.errorMessage = "";
      let response = await this.$store
        .dispatch("auth/logIn", {
          email: this.email,
          password: this.password
        })
        .catch(e => {
          this.loading = false;
          this.errorMessage =
            e?.response?.data?.message ||
            "Error on request... Please contact your administrator";
        });
      if (response === true) {
        const currentUser = this.$store.getters["auth/currentUser"];
        if (currentUser) {
          this.saveRecentUser({
            email: currentUser.email,
            name: currentUser.name || currentUser.user || ""
          });
        }
        await this.$store.dispatch("general/init", {
          store: null,
          departmentCode: null
        });
        // verify if any store selected on the localstorage - probably this will be done in an init before - get stores and them
        this.$router.replace(this.$route.query.redirect || this.defaultPage());
      }
      this.loading = false;
      return;
    },
    defaultPage() {
      return {
        name: "DashboardPage",
        params: this.urlParams
      };
    },
    selectUser(user) {
      this.selectedRecentUser = user;
      this.email = user.email;
      this.errorMessage = "";
      this.password = "";
      // Give time for the password field to appear
      this.$nextTick(() => {
        const pwdInput = document.querySelector('input[name="password"]');
        if (pwdInput) pwdInput.focus();
      });
    },
    saveRecentUser(user) {
      // Remove if already exists to move to top
      let list = this.recentUsers.filter(u => u.email !== user.email);
      list.unshift(user);
      // Keep only 3
      list = list.slice(0, 3);
      this.recentUsers = list;
      localStorage.setItem("recent_users", JSON.stringify(list));
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.align {
  background-color: $LoginBaseBgcolor;
  color: $LoginBaseColor;
  height: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;

  &__item {
    &--start {
      align-self: flex-start;
    }

    &--end {
      align-self: flex-end;
    }
  }
}

.site {
  &__logo {
    margin-bottom: 2rem;
  }
}

$input-placeholder-color: #7e8ba3;

input {
  border: 0;
  font: inherit;

  &::placeholder {
    color: $input-placeholder-color;
  }
}

.form {
  &__field {
    margin-bottom: 1rem;
  }

  input {
    outline: 0;
    padding: 0.5rem 1rem;

    &[type="email"],
    &[type="password"] {
      width: 100%;
    }
  }
}

$grid-max-width: 25rem;
$grid-width: 100%;

.grid {
  margin: 0 auto;
  max-width: $grid-max-width;
  width: $grid-width;
}

h2 {
  font-size: 2.75rem;
  font-weight: 100;
  margin: 0 0 1rem;
  text-transform: uppercase;
}

svg {
  height: auto;
  max-width: 100%;
  vertical-align: middle;
}

$link-color: #7e8ba3;

a {
  color: $link-color;
}

.register {
  background-color: $LoginFormBgcolor;
  box-shadow: 0 0 15px #000;
  text-align: center;
  border-radius: 7px;
  padding: 4rem 2rem;

  input {
    border: 1px solid #242c37;
    border-radius: 999px;
    background-color: transparent;
    text-align: center;
    color: $LoginBaseColor;

    &[type="email"],
    &[type="password"] {
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: 1rem 50%;
    }

    &[type="email"] {
      background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#242c37"><path d="M256.017 273.436l-205.17-170.029h410.904l-205.734 170.029zm-.034 55.462l-205.983-170.654v250.349h412v-249.94l-206.017 170.245z"/></svg>');
    }

    &[type="password"] {
      background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#242c37"><path d="M195.334 223.333h-50v-62.666c0-61.022 49.645-110.667 110.666-110.667 61.022 0 110.667 49.645 110.667 110.667v62.666h-50v-62.666c0-33.452-27.215-60.667-60.667-60.667-33.451 0-60.666 27.215-60.666 60.667v62.666zm208.666 30v208.667h-296v-208.667h296zm-121 87.667c0-14.912-12.088-27-27-27s-27 12.088-27 27c0 7.811 3.317 14.844 8.619 19.773 4.385 4.075 6.881 9.8 6.881 15.785v22.942h23v-22.941c0-5.989 2.494-11.708 6.881-15.785 5.302-4.93 8.619-11.963 8.619-19.774z"/></svg>');
    }

    &[type="submit"] {
      background-image: linear-gradient(
        160deg,
        $LoginBaseBgcolor 10%,
        $LoginBaseBgcolor 100%
      );
      color: $LoginBaseColor;
      margin-bottom: 6rem;
      width: 100%;
    }
    &[type="submit"]:hover {
      background-image: linear-gradient(
        160deg,
        $LoginBaseBgcolor 10%,
        $LoginBaseBgcolor 50%
      );
      opacity: 0.9;
    }
  }
}
</style>
